import { FormattedMessage } from 'react-intl';

import { useAdminAccountManagementEmptyStyles } from './AdminAccountManagementEmpty.styles';

export default function AdminAccountManagementEmpty() {
  const { styles } = useAdminAccountManagementEmptyStyles();

  return (
    <div className={styles.empty}>
      <FormattedMessage id="admin.accountManagement.chooseAccount" />
    </div>
  );
}
